import ReactQuill from 'react-quill';

const Inline = ReactQuill.Quill.import('blots/inline');

class CaptionFont extends Inline {
  static create() {
    const node = super.create();
    node.setAttribute('class', 'quill-caption');
    return node;
  }

  static formats(node) {
    return {
      class: node.getAttribute('class')
    };
  }
}

CaptionFont.blotName = 'caption';
export default CaptionFont;
